type MapExpression<T> = (expression: T) => { toString: () => string }

export default <T>(fn: MapExpression<T>) => (template: TemplateStringsArray, ...expressions: T[]) => template.reduce((acc, token, i) => acc + fn(expressions[i - 1]).toString() + token)
